import styles from "./chatFiles.module.scss";
import iconpdf from "../../../../styles/images/filepdf.svg";
import iconppt from "../../../../styles/images/fileppt.svg";
import iconword from "../../../../styles/images/fileword.svg";
import iconxls from "../../../../styles/images/fileexcel.svg";
import iconzip from "../../../../styles/images/filezip.svg";
import iconotherformat from "../../../../styles/images/otherformat.svg";
import { Tooltip } from "antd";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatAttachmentsOption from "../chatAttachmentOption";
import React, { useEffect, useState } from "react";
import moment from "moment";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import {
  excelFormats,
  pptFormats,
  zipFormats,
  mp3Formats,
  pdfFormats,
  videoFormat,
  getFileSize,
  imageFormat,
  strickerFormat,
  wordFormats,
  urlify,
  urlifyATmention
} from "../../../../base/utils";
import ChatVideoMessage from "../chatVideoMessage";
import ChatAudioMessage from "../audioChat";
import MultiChatImageMessage from "../MultiimageChat";
import { useSelector } from "react-redux";
import { chats, initialStateModel } from "../../../../models/model";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
import _ from "lodash";
import ImagePreview from "../MultiimageChat/imagePreview";
import ChatStickerMessage from "../chatSticker";
import ForwardHeader from "../forwardHeader";
import AllFilePreview from "../allFilePreview";
import { updateOpenstate } from "../../../../base/socketChatService/utils";

//const mime = require('mime');

type fileMessageProps = {
  data: any;
  groupdata?: any;
  searchedData?: any;
  savedData?: any;
  timeValue?: any;
};
type fileMessageState = {
  isOpen: boolean;
  id: any;
  imgArray: any;
  fileArray: any;
  audioArray: any;
  videoArray: any;
  audioVideo: any;
  allfileArray: any;
};
const ChatFilesMessage = React.memo(({ data, groupdata, searchedData, savedData, timeValue }: fileMessageProps) => {  
  const [fileState, setfileState] = useState<fileMessageState>({
    isOpen: false,
    id: "",
    imgArray: [],
    fileArray: [],
    audioArray: [],
    videoArray: [],
    allfileArray: [],
    audioVideo: 0
  });
  //let fileArr = Array.isArray(data) && data.length >0 && _.filter(data, function(o:any) { return o.message?.messageType === "FILE"; });
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let timeCount = timeValue !== undefined ? timeValue : 18;
  const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
  }, [savedData]);
  let fileArr =
    Array.isArray(data) && data.length > 0
      ? _.filter(data, function (o: any) {
          return o.message?.messageType === "FILE";
        })
      : [];
  let audioRes: any = [];
  let videoRes: any = [];
  let fileRes: any = [];
  _.forEach(fileArr, function (element: any) {
    let msg = _.isObject(element.message.body) ? element.message.body : element.message.body;

    if (mp3Formats.indexOf(msg?.fileType) !== -1) {
      audioRes.push(element);
    } else if (videoFormat.indexOf(msg?.fileType) !== -1) {
      videoRes.push(element);
    } else if (mp3Formats.indexOf(msg?.fileType) === -1 || videoFormat.indexOf(msg?.fileType) === -1) {
      fileRes.push(element);
    }
  });
  let imgArr =
    Array.isArray(data) && data.length > 0
      ? _.filter(data, function (o: any) {
          return o.message?.messageType === "IMAGE";
        })
      : [];
  let imgfileRes: any = [];
if(Array.isArray(imgArr) && imgArr.length > 0){
  let msg = Array.isArray(imgArr) &&  _.isObject(imgArr[0].message.body) ? imgArr[0].message.body : imgArr[0].message.body;
  if (strickerFormat.indexOf(msg?.fileType) !== -1) {
    let datRes = imgArr.reverse();
    var arr =_.chunk(datRes, 2);
    imgfileRes = arr.reverse();
  } else if (strickerFormat.indexOf(msg?.fileType) === -1 && imgArr?.length > 3) {
    imgfileRes.push(imgArr);
  } else if (strickerFormat.indexOf(msg?.fileType) === -1 && imgArr?.length < 4) {
    var arr1 =_.chunk(imgArr, 1);
    imgfileRes = arr1
  }  

}


  let { id, direction, timestamp, fromcaller_details } = Array.isArray(fileRes) && fileRes.length > 0 ? fileRes[0] : "";
  let messageBody = Array.isArray(data) && data?.length > 0 ? data[0].message.body : "";
  let isReply = Array.isArray(data) && data?.length > 0 && data[0].message?.isReply ? true : false;
  let messageType = Array.isArray(data) && data?.length > 0 ? data[0].message?.messageType : [];

  let htimestamp = moment(timestamp).format("hh:mm A");
  const [longText, setlongtext] = useState(0);
  let mstext = messageBody?.text;
  if(mstext && mstext !== ""){
    if (mstext?.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
  }
  if(messageBody?.mentionID !== '' && messageBody?.mentionID !== undefined ){
    let test = urlifyATmention(messageBody ,mstext)
    mstext = test;
   }
  const onclickgetId = (id: any) => {
    setfileState({ ...fileState, id: id });
    FilePreviewer();
  };

  const handleCheckBoxClick = (e: any) => {
    let deletedArray: any = chatReducer.selectMessageData;

    let index = [];
    if (e.target.checked) {
      let arr: any = [...deletedArray, ...fileRes];
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: arr
        }
      });
    } else {
      _.forEach(fileRes, function (element: any) {
        index = deletedArray.indexOf(element);
        deletedArray.splice(index, 1);
      });

      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: deletedArray
        }
      });
    }
  };

  const FilePreviewer = () => {
    setfileState({ ...fileState, isOpen: !fileState.isOpen });
    updateOpenstate(!fileState.isOpen );
  };

  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
  };  
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  let isBookmark:any = data[0]?.message?.isSave;
  let widthMulti = (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data[0]?.message?.isEdit ?"saveEdited": 
  (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data[0]?.message?.isEdit ? "onlyEdited" : "widthDefault";
  
  //Highlight FileName
  let message_text =
  messageBody?.fileName?.length > 25
    ? messageBody?.fileName?.substring(0, 25) + "..."
    : messageBody?.fileName;
  message_text = (searchedData !== "" && searchedData !== undefined) ?message_text:urlify(message_text);
  message_text = message_text?.replace(/\n/g, "<br />");
  if (searchedData !== "" && searchedData !== undefined && searchedData.search(/[\[\]?*+|{}\\\n\r]/) === -1) {
    var escaped_string = searchedData.replace(/[.*+?^${}()|[\]\\]/g,"\\$&");
    const regexs = new RegExp('(' + escaped_string + ')', 'gi');
    message_text = message_text?.replace(regexs,
      '<span style="background-color:#FBF4C5" tabindex="0" class="tranText">$1</span>');
  
  }

  
  return (
    <>
   {fileState?.isOpen &&  <AllFilePreview isOpen={fileState?.isOpen}
        data={Array.isArray(fileRes) && fileRes[0]}
        groupdata={groupdata}
        previewopen={onclickgetId} /> }
      {Array.isArray(groupdata) && groupdata.length > 0 && messageType === "FILE" && direction === "IN" ? (
        <div
          className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} lftMessage ${styles.chatMsg} ${
            styles.leftMessage
          }  ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(fileRes[0]) > -1 ) ? "checked" : chatReducer?.multiOption? "checking":""}`}
          id={id}
        >
          {!isReply && timeCount > 15 &&   <div className={`${styles.chatUserDetails}`}>
          <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon leftSide" />
            <div className={styles.convMemName}>
              {" "}
              <span>{fromcaller_details?.caller_id}</span>
            </div>
          </div>}
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              {!isReply && (
                <Tooltip
                  mouseEnterDelay={0.5}
                  title={htimestamp}
                  className="cusTooltip"
                  overlayClassName="customTooltip"
                >
                  <div className={styles.chatTime}>{htimestamp}</div>
                </Tooltip>
              )}
              <div className={`msgContentLft ${styles.chatContent}`}>
              {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                <div className={styles.chatAttachmentList}>
                  {Array.isArray(fileRes) &&
                    fileRes.length > 0 &&
                    fileRes.map((msgList: any, index: any) => {
                      let messageBody = msgList.message.body;                
                      if (msgList?.direction === "IN") {
                        return (
                          <>
                            <span className={id === savedData ? "focusText" : ""} tabIndex={0}>
                              {imageFormat.indexOf(messageBody?.fileType) === -1 &&
                                mp3Formats.indexOf(messageBody?.fileType) === -1 &&
                                videoFormat.indexOf(messageBody?.fileType) === -1 && (
                                  <div className={styles.filesChat}  onClick={() => onclickgetId(id)}>
                                    <div className={styles.filesImage}>
                                      {zipFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                        <img src={iconzip} alt="filename" />
                                      ) : pdfFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                        <img src={iconpdf} alt="filename" />
                                      ) : messageBody?.fileType && pptFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                        <img src={iconppt} alt="filename" />
                                      ) : excelFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                        <img src={iconxls} alt="filename" />
                                      ) : wordFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                        <img src={iconword} alt="filename" />
                                      ) : (
                                        <img src={iconotherformat} alt="filename" />
                                      )}
                                    </div>

                                    <div className={styles.filesDetails}>
                                      <Tooltip
                                        mouseEnterDelay={0.5}
                                        placement="top"
                                        title={messageBody?.fileName}
                                        overlayClassName="tooltipCenter"
                                      >
                                        <p dangerouslySetInnerHTML={{ __html: message_text?.replace(/\n/g, "<br />") }}></p> 
                                        {/* <p>{message_text}</p> */}
                                      </Tooltip>
                                      <span className={styles.fileName}>
                                        {zipFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "ZIP"
                                        ) : pdfFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "PDF"
                                        ) : messageBody?.fileType &&
                                          pptFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "PPT"
                                        ) : excelFormats.indexOf(messageBody?.fileType) !== -1 ? (messageBody?.fileType==='text/csv'?
                                          "CSV":"XLS"
                                        ) : wordFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "WORD"
                                        ) : (
                                          "OTHER"
                                        )}
                                          </span>
                                        •
                                      <span className={styles.fileDt}>{getFileSize(messageBody?.filesize)}</span>
                                    </div>
                                    {/* <div className={styles.attachmentHover} id={"hover" + msgList.id}>
                                      <ChatAttachmentsOption
                                        fromFiles={false}
                                        overAllFileData={fileRes}
                                        data={msgList}
                                        previewopen={onclickgetId}
                                        hoverdata={Array.isArray(fileRes) && fileRes?.length > 0 && fileRes[0]}
                                      />
                                    </div> */}
                                  </div>
                                )}
                            </span>
                            {imageFormat.indexOf(messageBody?.fileType) !== -1 && (
                              <ImagePreview data={msgList} multiData={data}></ImagePreview>
                            )}
                            {/* {mp3Formats.indexOf(messageBody?.fileType) !== -1 && <ChatAudioInner data={msgList} userDetails ={fromcaller_details}/>}
                        {videoFormat.indexOf(messageBody?.fileType) !== -1 && <ChatVideoPlayer  data={msgList}></ChatVideoPlayer>} */}
                          </>
                        );
                      } else {
                        return null;
                      }
                    })}
                </div>
                
             
                      <div className="textContent">
                     {messageBody?.text && messageBody?.text !== "" &&  <span className={styles.messageContent} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>}
                      <span className={widthMulti}></span>
                    </div>
                    
                {!isReply && (
                  <ChatLeftInfo userDetails={fromcaller_details} timeStamp={timestamp} message={data}></ChatLeftInfo>
                )}
                {!isReply && (
                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption
                      className="hoverList hoverListleft"
                      data={Array.isArray(fileRes) && fileRes?.length > 0 && fileRes[0]}
                      multiFile={fileRes}
                      highlightHover={handlehighlightHover}
                    />
                  </div>
                )}
              </div>
            </div>
            {!isReply && (
              <ChatLike className="likeLeft" placement="top" tooltipTitle={data?.likeduserdetails} message={data[0]} />
            )}
          </div>

          {!isReply && (!chatReducer?.isDelete && chatReducer?.multiOption) && Array.isArray(data) && data?.length > 0 && (
            <URCheckBoxCall
              checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
              className="chatSelectRight"
              onChange={handleCheckBoxClick}
            />
          )}
        </div>
      ) : (
        Array.isArray(groupdata) &&
        groupdata.length > 0 &&
        fileRes.length > 0 &&
        messageType === "FILE" && (
          <div
            className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} rtMessage ${styles.chatMsg} ${
              styles.rightMessage
            } 
            ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(fileRes[0]) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`}
            id={id}
          >
           {!isReply && fileState?.imgArray.length === 0 && timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
             <div className={styles.convMemName}>
                <span>You</span>
              </div>
             <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon rightSide" />
            </div>}
            <div className={styles.chatRightMessages}>
              <div className={styles.chatRight}>
                <div className={`msgContentRT ${styles.chatContent}`}>
                {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                  <div
                    className={isReply ? `${styles.chatAttachmentList} ${styles.fileAlign}` : styles.chatAttachmentList}
                  >
                    {Array.isArray(fileRes) &&
                      fileRes.length > 0 &&
                      fileRes.map((msgList: any, index: any) => {
                        // let messageBody =   _.isObject(msgList.message.body) ?  msgList.message.body : JSON.parse(msgList.message.body);
                        let messageBody = msgList.message.body;
                        if (msgList?.direction === "OUT") {
                          return (
                            <>
                              <span className={id === savedData ? "focusText" : ""} tabIndex={0}>
                                {imageFormat.indexOf(messageBody?.fileType) === -1 &&
                                  mp3Formats.indexOf(messageBody?.fileType) === -1 &&
                                  videoFormat.indexOf(messageBody?.fileType) === -1 && (
                                    <div className={styles.filesChat}  onClick={() => onclickgetId(id)}>
                                      <div className={styles.filesImage}>
                                        {zipFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          <img src={iconzip} alt="filename" />
                                        ) : pdfFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          <img src={iconpdf} alt="filename" />
                                        ) : messageBody?.fileType &&
                                          pptFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          <img src={iconppt} alt="filename" />
                                        ) : excelFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          <img src={iconxls} alt="filename" />
                                        ) : wordFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          <img src={iconword} alt="filename" />
                                        ) : (
                                          <img src={iconotherformat} alt="filename" />
                                        ) }
                                      </div>
                                      <div className={styles.filesDetails}>
                                        <Tooltip
                                          mouseEnterDelay={0.5}
                                          placement="top"
                                          title={messageBody?.fileName}
                                          overlayClassName="tooltipCenter"
                                        >
                                          <p dangerouslySetInnerHTML={{ __html: message_text?.replace(/\n/g, "<br />") }}></p> 
                                          {/* <p>{message_text}</p> */}
                                        </Tooltip>
                                        <span className={styles.fileName}>
                                        {zipFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "ZIP"
                                        ) : pdfFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "PDF"
                                        ) : messageBody?.fileType &&
                                          pptFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "PPT"
                                        ) : excelFormats.indexOf(messageBody?.fileType) !== -1 ? (messageBody?.fileType==='text/csv'?
                                          "CSV":"XLS"
                                        ) : wordFormats.indexOf(messageBody?.fileType) !== -1 ? (
                                          "WORD"
                                        ) : (
                                          "OTHER"
                                        )}
                                          </span>
                                        •
                                        <span className={styles.fileDt}>{getFileSize(messageBody?.filesize)}</span>
                                      </div>
                                      {/* <div className={styles.attachmentHover} id={"hover" + msgList.id}>
                                        <ChatAttachmentsOption
                                          fromFiles={false}
                                          overAllFileData={fileRes}
                                          data={msgList}
                                          previewopen={onclickgetId}
                                          hoverdata={Array.isArray(fileRes) && fileRes?.length > 0 && fileRes[0]}
                                        />
                                      </div> */}
                                    </div>
                                  )}
                                {imageFormat.indexOf(messageBody?.fileType) !== -1 && (
                                  <ImagePreview data={msgList} multiData={data} index={0}></ImagePreview>
                                )}
                                {/* {mp3Formats.indexOf(messageBody?.fileType) !== -1 && <ChatAudioInner data={msgList} userDetails ={fromcaller_details}/>}
                        {videoFormat.indexOf(messageBody?.fileType) !== -1 && <ChatVideoPlayer  data={msgList}></ChatVideoPlayer>} */}
                              </span>
                            </>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>
                  
                      <div className="textContent">
                      {messageBody?.text && messageBody?.text !== "" && <span className={styles.messageContent} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>}
                      <span className={widthMulti}></span>
                    </div>
                    
                  {!isReply && fileState?.imgArray.length === 0 && (
                    <ChatRightInfo
                      userDetails={fromcaller_details}
                      timeStamp={timestamp}
                      message={Array.isArray(data) && data.length > 0 ? data[0] : []}
                    ></ChatRightInfo>
                  )}
                  {!isReply && (
                    <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                      <ChatHoverOption
                        className="hoverList hoverListright"
                        data={fileRes[0]}
                        multiFile={fileRes}
                        highlightHover={handlehighlightHover}
                      />
                    </div>
                  )}
                </div>
                {!isReply && (
                  <Tooltip
                    mouseEnterDelay={0.5}
                    placement="topRight"
                    title={htimestamp}
                    className="cusTooltip"
                    overlayClassName="customTooltip"
                  >
                    <div className={styles.chatTime}>{htimestamp}</div>
                  </Tooltip>
                )}
              </div>
              {!isReply && (
                <ChatLike
                  className="likeRight"
                  placement="topRight"
                  tooltipTitle={data?.likeduserdetails}
                  message={data[0]}
                />
              )}
            </div>

            {!isReply && (!chatReducer?.isDelete && chatReducer?.multiOption) &&
              Array.isArray(fileRes) &&
              fileRes?.length > 0 && (
                <URCheckBoxCall
                  checked={chatReducer?.selectMessageData?.indexOf(fileRes[0]) > -1 ? true : false}
                  className="chatSelectRight"
                  onChange={handleCheckBoxClick}
                />
              )}
          </div>
        )
      )}
      {imgfileRes.map((datalist: any, i: any) => {
       // var timeRes = i === imgfileRes?.length - 1 ? timeValue : i;
       var timeRes = datalist[0].indexValue === 0 ? 18 : i;
        return (
          <>
            {strickerFormat.indexOf(messageBody?.fileType) !== -1 && messageType === "IMAGE" && (
              <ChatStickerMessage
                data={datalist}
                multiData={datalist}
                audioVideo={true}
                previewopen={onclickgetId}
                savedData={savedData}
                timeValue={timeRes}
              ></ChatStickerMessage>
            )}
            {strickerFormat.indexOf(messageBody?.fileType) === -1 &&
              Array.isArray(groupdata) &&
              groupdata.length > 0 &&
              messageType === "IMAGE" &&
              (
                <MultiChatImageMessage
                  data={datalist}
                  multiData={datalist}
                  audioVideo={fileState?.audioVideo}
                  previewopen={onclickgetId}
                  savedData={savedData}
                  timeValue={timeRes}
                />
              )}
          </>
        );
      })}

      {Array.isArray(groupdata) && groupdata.length > 0 && messageType === "FILE" && audioRes.length > 0 && (
        <ChatAudioMessage data={audioRes} multiData={audioRes} savedData={savedData} timeValue={timeValue} />
      )}
      {Array.isArray(groupdata) && groupdata.length > 0 && messageType === "FILE" && videoRes.length > 0 && (
        <ChatVideoMessage data={videoRes} previewopen={onclickgetId} savedData={savedData} timeValue={timeValue}/>
      )}
    </>
  );
});

export default ChatFilesMessage;